import axios from "../../../config/axiosConfig";

export const listWialonUsers = ({
  search = "",
  page = 1,
  limit = 50,
  groupBy = 0,
  onlyLinked = 0,
  cod_servicio_cliente,
} = {}) =>
  axios.get("/api/wialon/usuarios", {
    params: { search, page, limit, groupBy, onlyLinked, cod_servicio_cliente },
  });

export const getWialonUserDetalle = (itemId) =>
  axios.get(`/api/wialon/usuarios/${itemId}/detalle`);

export const createWialonUser = (body) => axios.post("/api/wialon/usuarios", body);

export const updateWialonUser = (userId, body) =>
  axios.patch("/api/wialon/usuarios", {
    userId,
    ...body,
  });

export const deleteWialonUser = (itemId) =>
  axios.delete("/api/wialon/usuarios", { data: { itemId } });

// Solo quita la vinculación local con el cliente — no borra el usuario en Wialon.
// cod_servicio_cliente es opcional pero recomendado: un usuario puede tener
// vinculaciones activas con más de un cliente (ver Panel Global), así que sin
// ese dato el backend podría desvincular la de otro cliente distinto.
export const desvincularWialonUser = (itemId, codServicioCliente) =>
  axios.post(`/api/wialon/usuarios/${itemId}/desvincular`, {
    cod_servicio_cliente: codServicioCliente,
  });

export const listWialonUnits = ({ search = "", page = 1, limit = 25 } = {}) =>
  axios.get("/api/wialon/unidades", { params: { search, page, limit } });

export const listWialonHwTypes = ({ search = "", page = 1, limit = 30 } = {}) =>
  axios.get("/api/wialon/hw-types", { params: { search, page, limit } });

export const listWialonIconLibrary = ({ type = "unit", flags = 0, resId = 0, size = 64 } = {}) =>
  axios.get("/api/wialon/iconos-biblioteca", { params: { type, flags, resId, size } });

export const listWialonChipsDisponibles = ({ search = "", limit = 20 } = {}) =>
  axios.get("/api/wialon/chips-disponibles", { params: { search, limit } });

export const listWialonUnitGroups = ({ search = "", page = 1, limit = 30 } = {}) =>
  axios.get("/api/wialon/grupos-unidades", { params: { search, page, limit } });

export const createWialonUnitGroup = (body) =>
  axios.post("/api/wialon/grupos-unidades", body);

export const updateWialonUnitGroup = (itemId, body) =>
  axios.patch(`/api/wialon/grupos-unidades/${itemId}`, body);

export const getWialonUnitGroupHistory = (itemId, { page = 1, limit = 30 } = {}) =>
  axios.get(`/api/wialon/grupos-unidades/${itemId}/historial`, { params: { page, limit } });

export const createWialonUnit = (body) =>
  axios.post("/api/wialon/unidades", body);

export const updateWialonUnit = (sysId, body) =>
  axios.patch(`/api/wialon/unidades/${sysId}`, body);

export const deleteWialonUnit = (sysId) =>
  axios.delete(`/api/wialon/unidades/${sysId}`);

export const syncWialonUnit = (sysId) =>
  axios.post(`/api/wialon/unidades/${sysId}/sincronizar`);
